// src/contexts/AuthContext.jsx

import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Initialize auth state with token from localStorage and no user details yet.
  const [auth, setAuth] = useState({
    token: localStorage.getItem("token"),
    user: null,
  });

  // Function to remove user data and token, then update state.
  const logout = () => {
    console.log("Logging out");
    setAuth({ token: null, user: null });
    localStorage.removeItem("token");
  };

  // When the token changes, decode it to extract user info.
  useEffect(() => {
    if (auth.token && !auth.user) {
      try {
        const decoded = jwtDecode(auth.token);
        // ✨ Normalize: Ensure 'id' exists (map from 'sub' if needed)
        const user = { ...decoded, id: decoded.sub || decoded.id };
        setAuth((prev) => ({ ...prev, user }));
      } catch (error) {
        console.error("Error decoding token:", error);
        logout();
      }
    }
  }, [auth.token]);

  // Function to update auth state when a user logs in.
  const login = (data) => {
    console.log("Logging in with data:", data);
    try {
      const decoded = jwtDecode(data.token);
      // ✨ Normalize here as well
      const user = { ...decoded, id: decoded.sub || decoded.id };
      setAuth({ token: data.token, user });
      localStorage.setItem("token", data.token);
    } catch (error) {
      console.error("Error decoding token during login:", error);
      setAuth({ token: null, user: null });
    }
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
